import BpkText from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { BreakfastPolicyDetails } from '@shared/types/hotel-content';
import type { BreakfastPolicyItemItemType } from '@skyscanner-internal/hotel-unified-bff-web-http-client/dist/skyscanner/hotelunifiedbff/hotelcontent/v1/hotel_content.pb';

import STYLES from './BreakfastPolicy.module.scss';

const cls = cssModules(STYLES);

type DetailProps = {
  content?: string;
  title: string;
  itemKey: BreakfastPolicyItemItemType;
};
const Detail = ({ content, itemKey, title }: DetailProps) => (
  <div className={cls('BreakfastPolicy__detail')} key={itemKey}>
    <div className={cls('BreakfastPolicy__detail--title')}>
      <BpkText tagName="p">{title}</BpkText>
    </div>

    <div className={cls('BreakfastPolicy__detail--content')}>
      <BpkText tagName="p">{content}</BpkText>
    </div>
  </div>
);

type Props = {
  key: string;
  policy: BreakfastPolicyDetails;
};

const BreakfastPolicy = ({ key, policy }: Props) => {
  const breakfastDetail = policy.items;

  return (
    <div key={key} className={STYLES.BreakfastPolicy}>
      <BpkText
        tagName="p"
        className={cls(
          !breakfastDetail?.length && 'BreakfastPolicy__smallContent',
        )}
      >
        {policy.title}
      </BpkText>
      {breakfastDetail.map((item) => {
        const { details, displayName, type } = item;
        return (
          displayName &&
          type &&
          details && (
            <Detail
              itemKey={type}
              title={displayName}
              content={details.join(', ')}
            />
          )
        );
      })}
    </div>
  );
};

export default BreakfastPolicy;
